<template>
  <div class="tooltip" :class="{ popover:isPopover}" :placement="placement" ref="tooltip">
    <div class="tooltip-inner">
      <slot></slot>
    </div>
    <div class="tooltip-arrow" :class="{ 'popover-arrow':isPopover}"></div>
  </div>
</template>

<script>
  /* eslint-disable no-undef */
  export default {
    props: {
      refElemId: {
        type: String,
        required: true
      },
      isPopover: {
        type: Boolean,
        default: false
      },
      placement: {
        type: String,
        required: true
      },
      trigger: {
        type: String | Array,
        required: true
      }
    },
    computed: {
      refElem () {
        return document.getElementById(this.refElemId)
      }
    },
    created () {
      setTimeout(() => {
        let trigger = this.trigger
        if (!Array.isArray(trigger)) {
          trigger = [trigger]
        }

        for (let val of trigger) {
          if (val === 'click') {
            this.refElem.addEventListener('click', event => {
              event.stopPropagation()
              this.toggleTooltip()
            })
            this.$refs.tooltip.addEventListener('click', event => {
              event.stopPropagation()
            })
          } else if (val === 'hover') {
            this.refElem.addEventListener('mouseenter', () => {
              this.toggleTooltip()
            })
            this.refElem.addEventListener('mouseleave', () => {
              this.hideTooltip()
            })
          }
        }
      }, 1000)
    },
    methods: {
      /**
       * Toggle tooltip
       *
       * @returns {void}
       */
      toggleTooltip () {
        const tooltipElem = this.$refs.tooltip
        if (tooltipElem.classList.contains('open')) {
          this.hideTooltip()
        } else { // Set tooltip position in respect to parent element
          tooltipElem.classList.add('open')
          window.events.$emit('tooltipShown', this.refElemId)

          setTimeout(() => {
            const refElemBound = this.refElem.getBoundingClientRect() // Getting parent element coordinates
            const tooltipElemBound = tooltipElem.getBoundingClientRect() // Tooltip coordinates
            tooltipElem.style.left = (this.refElem.offsetLeft + refElemBound.width - tooltipElemBound.width - 2) + 'px'
            tooltipElem.style.top = (this.refElem.offsetTop - tooltipElemBound.height - 7) + 'px'
          }, 0)
        }
      },
      /**
       * Hide tooltip
       *
       * @returns {void}
       */
      hideTooltip () {
        const tooltipElem = this.$refs.tooltip
        tooltipElem.classList.remove('open')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/widgets/Tooltip.vue